import { hasTouch } from "../common/_helpers";

export function ComponentBox() {
  $('.box').on('mouseenter', function (e) {
    $(this).removeClass('transition-out transition-left transition-right transition-top transition-bottom');

    if (e.originalEvent.layerX < 50) {
      $(this).addClass('transition-left');
    } else if (e.originalEvent.layerY < 50) {
      $(this).addClass('transition-top');
    } else if (e.originalEvent.layerX > $(this).width() - 50) {
      $(this).addClass('transition-right');
    } else {
      $(this).addClass('transition-bottom');
    }

    $(this).addClass('transition-in');

    var self = this;
    setTimeout(function () {
      $(self).addClass('hover');
      $(self).removeClass('transition-in');
    }, 50);
  });

  $('.box').on('mouseleave', function (e) {
    $(this).removeClass('transition-left transition-right transition-top transition-bottom');

    var self = this;
    setTimeout(function () {
      $(self).addClass('transition-out');
      $(self).removeClass('hover');
    }, 50);

    if (e.originalEvent.offsetX < 50) {
      $(this).addClass('transition-left');
    } else if (e.originalEvent.offsetY < 50) {
      $(this).addClass('transition-top');
    } else if (e.originalEvent.offsetX > $(this).width() - 50) {
      $(this).addClass('transition-right');
    } else {
      $(this).addClass('transition-bottom');
    }
  });

  $('.box').on('click', function (e) {
    if ($(window).width() < 768) return;
    if ($(this).attr('href') == '#') e.preventDefault();

    if (hasTouch()) {
      if ($(this).hasClass('hover')) {
        $('.box').removeClass('hover');
      } else {
        $('.box').removeClass('hover');
        $(this).addClass('hover');
      }
    }
  });
}
